/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GoogleCalendarService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Google Notification
   * https://developers.google.com/calendar/api/guides/push#receiving-notifications
   * @param id
   * @param xGoogChannelId
   * @param xGoogMessageNumber
   * @param xGoogResourceId
   * @param xGoogResourceState
   * @param xGoogResourceUri
   * @param xGoogChannelExpiration
   * @param xGoogChannelToken
   * @returns void
   * @throws ApiError
   */
  public googleNotificationV1WorkspaceSlugIntegrationsIdGoogleNotificationPost(
    id: number,
    xGoogChannelId: string,
    xGoogMessageNumber: number,
    xGoogResourceId: string,
    xGoogResourceState: 'sync' | 'exists' | 'not_exists',
    xGoogResourceUri: string,
    xGoogChannelExpiration?: string | null,
    xGoogChannelToken?: string | null
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/integrations/{id}/google-notification',
      path: {
        id: id,
      },
      headers: {
        'X-Goog-Channel-ID': xGoogChannelId,
        'X-Goog-Message-Number': xGoogMessageNumber,
        'X-Goog-Resource-ID': xGoogResourceId,
        'X-Goog-Resource-State': xGoogResourceState,
        'X-Goog-Resource-URI': xGoogResourceUri,
        'X-Goog-Channel-Expiration': xGoogChannelExpiration,
        'X-Goog-Channel-Token': xGoogChannelToken,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * @deprecated
   * Google Notification
   * https://developers.google.com/calendar/api/guides/push#receiving-notifications
   * @param id
   * @param xGoogChannelId
   * @param xGoogMessageNumber
   * @param xGoogResourceId
   * @param xGoogResourceState
   * @param xGoogResourceUri
   * @param xGoogChannelExpiration
   * @param xGoogChannelToken
   * @returns void
   * @throws ApiError
   */
  public googleNotificationV1WorkspaceSlugIntegrationIdGoogleNotificationPost(
    id: number,
    xGoogChannelId: string,
    xGoogMessageNumber: number,
    xGoogResourceId: string,
    xGoogResourceState: 'sync' | 'exists' | 'not_exists',
    xGoogResourceUri: string,
    xGoogChannelExpiration?: string | null,
    xGoogChannelToken?: string | null
  ): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/integration/{id}/google-notification',
      path: {
        id: id,
      },
      headers: {
        'X-Goog-Channel-ID': xGoogChannelId,
        'X-Goog-Message-Number': xGoogMessageNumber,
        'X-Goog-Resource-ID': xGoogResourceId,
        'X-Goog-Resource-State': xGoogResourceState,
        'X-Goog-Resource-URI': xGoogResourceUri,
        'X-Goog-Channel-Expiration': xGoogChannelExpiration,
        'X-Goog-Channel-Token': xGoogChannelToken,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
